import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-pricing',
  templateUrl: './help-pricing.component.html',
  styleUrls: ['./help-pricing.component.scss']
})
export class HelpPricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
